module.exports = __webpack_public_path__ + "assets/circlekLarge.2a5cc99a.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/logos/circlekLarge.png
// module id = 271
// module chunks = 1